/* eslint-disable prettier/prettier */
import { LanTwoTone } from "@mui/icons-material";
import React, { useState } from "react";
import { useTranslation } from 'react-i18next'
import styled from "styled-components";
import { GameDefinitionData } from "../../data/GameDefinitionData";

/*
This Modal appears when a milestone is reached. Have a different design when the Mileston is the
first one. The handleMilestoneStatus function return the stage of the milestone.
There is 5 different milestone stages
*/
const InnerContainer = styled.div`
  width: 600px;
  height: 320px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  text-align: center;
  position: absolute;
  font-family: "Roboto", sans-serif;
  z-index: 26;
  animation: zoomIn 0.2s ease-in-out;
`;
const TextContainer = styled.div`
  height: 57%;
`;
const Br = styled.div`
  height: 15%;
`;
const HeaderText = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 12%;
  color: ${(props) => props.theme.colors.black};
  height: 14%;
`;
const ParagraphText = styled.div`
  font-size: 16px;
  line-height: 110%;
  color: ${(props) => props.theme.colors.black};
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5px auto;
  height: 85%;
`;
const ParagraphListOfItems = styled.div`
  text-align: center;
  padding: 5px 0;
`;
const ParagraphFirstLine = styled.p`
  text-align: center;
`;
const ButtonContainer = styled.button`
  width: 40%;
  height: 75%;
  background: ${(props) => props.theme.colors.darkGreen};
  border-radius: 8px;
  cursor: pointer;
  border: none;
`;
const SeeInfoButtonContainer = styled.button`
  width: 40%;
  height: 75%;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.darkGreen};
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
`;
const ButtonContainerLine = styled.div`
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: space-evenly;
`;
const GetStartedButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 2.05vh;
  color: ${(props) => props.theme.colors.white};
  width: 100%;
`;
const ShowInfoButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 2.05vh;
  color: ${(props) => props.theme.colors.darkGreen};
  width: 100%;
`;
const MilestoneModal = ({
  title,
  paragraph,
  toggleMilestoneModal,
  MilestoneState,
  show,
  openStage,
  toggleProject,
  position,
  handleMilestone,
  toggleAfterMilestonePopUp,
  showAfterModal,
  ProjectScopeDisable,
  toggleMilestonCkeckbox,
  afterMilestonChecked,
  endTurn,
  handleCard,
  toggleIsAnimationNeeded,
  lastMilestone,
  Board,
  toggleExecutePopUp,
  needsToDelayExecutePopup,
  toggleNeedsToDelayExecutePopup,
  isPaused,
  toggleExecuteGPMTOnMilestone,
  toggleIsFirstMileStonePassed,
  toggleSideLogAnimation,
  needToOpenProjectSheetAfterMilestonePopUp,
  toggleOpenSheetAfterPopUp,
}) => {
  const { t } = useTranslation();
  let mileStoneBoardTile;
  let mileStoneStandard;
  let mileStoneExpensive;
  let mileStoneSenior;
  let mileStoneBudget;
  const lastMileStone = lastMilestone();
  if (lastMileStone) {
    mileStoneBoardTile = Board[lastMileStone];
    mileStoneStandard = mileStoneBoardTile.milestone.resources.standard;
    mileStoneSenior = mileStoneBoardTile.milestone.resources.senior;
    mileStoneExpensive = mileStoneBoardTile.milestone.resources.expensive;
    mileStoneBudget = mileStoneBoardTile.milestone.resources.budget;
  }

  const handleStepOnMilestone = () => {
    // ADD BOARD EXECUTED HERE
    if (position === lastMileStone) {
      return true;
    }
    return false;
  };
  if (show == false) return null;
  return (
    <InnerContainer>
      {toggleSideLogAnimation("milestone")}
      <Br />

      <TextContainer>
        {MilestoneState &&
          !handleStepOnMilestone() &&
          mileStoneBoardTile?.milestone?.id == 1 && (
            <HeaderText> {t('modals.after_milestone.info_title')}</HeaderText>
          )}
        {MilestoneState && handleStepOnMilestone() && (
          <HeaderText> {t('modals.milestone_reached.info_title')}</HeaderText>
        )}
        {!MilestoneState && (
          <HeaderText>
            {handleStepOnMilestone() ? t('modals.milestone_reached.info_title'): t('modals.after_milestone.info_title')}
          </HeaderText>
        )}
        <ParagraphText>
          {MilestoneState && (
            <ParagraphFirstLine>
              {handleStepOnMilestone()
                ? t('modals.milestone_reached.info_text')
                : t('modals.after_milestone.info_text')}
            </ParagraphFirstLine>
          )}
          {!MilestoneState && (
            <ParagraphFirstLine>
              {handleStepOnMilestone()
                ? t('modals.milestone_reached.info_text')
                : t('modals.after_milestone.info_text')}
            </ParagraphFirstLine>
          )}
          <ParagraphListOfItems>
            <div>
              {mileStoneBoardTile.milestone.resources.standard != 0 && (
                <div>{mileStoneStandard} {t('modals.after_milestone.regular')}</div>
              )}
              {mileStoneBoardTile.milestone.resources.senior != 0 && (
                <div>{mileStoneSenior} {t('modals.after_milestone.senior')}</div>
              )}
              {mileStoneBoardTile.milestone.resources.expensive != 0 && (
                <div>{mileStoneExpensive} {t('modals.after_milestone.executive')}</div>
              )}
              {mileStoneBudget != 0 && <div>${mileStoneBudget}</div>}
            </div>
          </ParagraphListOfItems>
        </ParagraphText>
      </TextContainer>
      <ButtonContainerLine>
        {handleStepOnMilestone() && (
          <ButtonContainer
            onClick={() => {
              if (MilestoneState) {
                toggleIsFirstMileStonePassed(false);
              }
              // isPaused(true);
              ProjectScopeDisable(true);
              console.log(206);
              toggleIsAnimationNeeded(false, true);
              toggleProject(1);
              toggleMilestoneModal(false);
              mileStoneBoardTile.milestone.passed = true;
              if (!afterMilestonChecked) {
                toggleAfterMilestonePopUp(true);
                mileStoneBoardTile.milestone.passed = true;
              }
              toggleExecuteGPMTOnMilestone(true);
            }}
            style={{
              backgroundColor: "#ffffff",
              color: "#005857",
              border: "1px solid #005857",
            }}
          >
            <GetStartedButton style={{ color: "#005857" }}>
              {t('modals.milestone_reached.button1')}
            </GetStartedButton>
          </ButtonContainer>
        )}
        <ButtonContainer
          onClick={() => {
            if (MilestoneState) {
              toggleIsFirstMileStonePassed(false);
            }
            // the turn needs to end
            if (!handleStepOnMilestone()) {
              mileStoneBoardTile.milestone.passed = true;
              if (
                Board[position].type !=
                ("planned-task" || "mile-stone" || "gate")
              ) {
                handleCard(Board[position].type);
              } else {
                console.log(
                  "yoni :)",
                  needToOpenProjectSheetAfterMilestonePopUp
                );
                // if (needsToDelayExecutePopup) {
                //   toggleExecutePopUp(true);
                //   toggleNeedsToDelayExecutePopup(false);
                //   toggleIsAnimationNeeded(false, true);
                //   return;
                // }
                // toggleProject(0);
                if (needToOpenProjectSheetAfterMilestonePopUp) {
                  toggleProject(0);
                } else {
                  toggleOpenSheetAfterPopUp(true);
                  toggleExecutePopUp(true);
                }
              }
            }
            if (handleStepOnMilestone()) {
              mileStoneBoardTile.milestone.passed = true;
              endTurn();
            }
            toggleMilestoneModal(false);
          }}
        >
          <GetStartedButton>
            {handleStepOnMilestone() ? t('modals.milestone_reached.button2') : t('modals.after_milestone.button1')}
          </GetStartedButton>
        </ButtonContainer>
      </ButtonContainerLine>
    </InnerContainer>
  );
};

// } else if (position == 31 || position == 50) {
//     handleCard('Risk');
// } else if (
//     position == 21 ||
//     position == 30 ||
//     position == 42 ||
//     position == 47 ||
//     position == 56
// ) {
//     handleCard('unplanned-task');
export default React.memo(MilestoneModal);
